import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { IOrderTrackingData } from '../../../../utils/order-status/interfaces'
import type { TierInfo } from '../../../../utils/loyalty/types'

const bem = new BEMHelper('PrimaryStatus')

declare global {
    interface Window {
        SF: {
            getTierThresholds: () => { identifier: string, value: string | null, maxValue: string | null }[]
            getContactDetails: () => { customerCare: CustomerCareContact }
            getTierInfo: (shouldRedirect?: boolean) => TierInfo
            getUserSummary: () => { loyaltyConsent: string, loyaltySegment: string }
        }
    }
}

type CustomerCareContact = {
    telephone: string
    email: string
}

type PrimaryStatusProps = {
    orderPrimaryStatus: IOrderTrackingData
    withDescription?: boolean
    messages: any
    noCenter?: boolean,
    className?: string
}

const PrimaryStatus: React.FC<PrimaryStatusProps> = ({ orderPrimaryStatus, withDescription, messages, noCenter, className }) => {
    const { title, description, dotStatus } = orderPrimaryStatus
    const { telephone = '', email = '' } =
        (typeof window !== 'undefined' && window.SF?.getContactDetails?.()?.customerCare) || {}

    const phone = `<a href="tel:${telephone}">${messages.orderStatusDesc.phone()}</a>`
    const mail = `<a href="mailto:${email}">${messages.orderStatusDesc.email()}</a>`

    return (
        <div className={bem(null, noCenter ? 'noCenter' : '')}>
            <div className={bem('orderStatusTitle', dotStatus, className)}>{title}</div>
            {withDescription && description && (
                <div
                    className={bem('orderStatusDescription')}
                    dangerouslySetInnerHTML={{ __html: description({ phone, mail }) }}
                ></div>
            )}
        </div>
    )
}

export default PrimaryStatus
